import React from 'react';
import {
    SearchBoxContainer,
    StyledI,
    StyledSpan,
    StyledInputText,
} from './SearchBox.styled';
import { useSelector } from 'react-redux';
const SearchBox = (props) => {
    const {
        id,
        updateSearch,
        searchProduct,
        width,
        paddingLeft,
        borderRadius,
        isSearchIcon,
        placeholder,
        margin,
        right,
        fontSize,
        iconColor,
        iconMarginLeft,
        iconMarginRight,
        iconPaddingLeft,
        borderLeft,
        marginTop,
        fontWeight,
        containerMobileWidth,
        searchIconWidth,
        handleKeyPress,
        onClick,
        onBlur,
        placeHolderFontFamily,
        placeholderMarginLeft,
        placeholderPaddingLeft,
        placeholderFontWeight,
        height,
        paddingRight,
        background,
        enterkeyhint = 'none',
        borderColor,
        searchRef,
        marginDesktop,
        marginIpad,
        padding,
        opacity,
        autoComplete,
        isPopUp = false,
        isCalendar = false,
        isActiveSearch,
        clearSearch
    } = props;
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    return (
        <SearchBoxContainer
            width={width}
            isActiveSearch={isActiveSearch}
            isCalendar={isCalendar}
            margin={margin}
            fontSize={fontSize}
            containerMobileWidth={containerMobileWidth}
            background={background}
            marginDesktop={
                isCalendar
                    ? '0px 15px 0px 15px'
                    : !props.filterPage && isCondensedView
                    ? '8px 8px'
                    : marginDesktop
            }
            marginIpad={marginIpad}
        >
            <StyledSpan
                isPopUp={isPopUp}
                isCalendar={isCalendar}
                width={width}
                className={
                    isSearchIcon
                        ? 'p-input-icon-left p-input-icon-right'
                        : 'p-input-icon-right'
                }
            >
                {isSearchIcon && (
                    <StyledI
                        isCalendar={isCalendar}
                        isPopUp={isPopUp}
                        style={{
                            color: iconColor ? iconColor : '#6c757d',
                            fontWeight: fontWeight ? fontWeight : 'normal',
                            width: searchIconWidth ? searchIconWidth : '',
                            left: iconMarginLeft ? iconMarginLeft : '0.5rem',
                            right: iconMarginRight ? iconMarginRight : '0.5rem',
                            borderLeft: borderLeft
                                ? borderLeft
                                : '1px solid #707070',
                            paddingLeft: iconPaddingLeft
                                ? iconPaddingLeft
                                : '5px',
                            paddingRight: paddingRight ? paddingRight : '10px',
                        }}
                    ></StyledI>
                )}
                <StyledInputText
                    placeholderMarginLeft={placeholderMarginLeft}
                    placeholderPaddingLeft={placeholderPaddingLeft}
                    placeholderFontWeight={placeholderFontWeight}
                    id={id}
                    style={{
                        width: width,
                        borderRadius: borderRadius,
                        paddingLeft: paddingLeft,
                        marginTop: marginTop,
                        fontSize: fontSize ? fontSize : '1rem',
                        fontFamily: placeHolderFontFamily
                            ? placeHolderFontFamily
                            : '',
                        boxShadow: 'none',
                        outline: 0,
                        WebkitAppearance: 'none',
                        borderColor: borderColor ? borderColor : '#ced4da',
                        height: height,
                        paddingRight: paddingRight,
                        padding: padding,
                        opacity: opacity,
                    }}
                    value={searchProduct}
                    onChange={
                        isCalendar || isPopUp
                            ? updateSearch
                            : (e) => updateSearch(e.target.value)
                    }
                    placeholder={placeholder}
                    onKeyDown={
                        isCalendar || isPopUp
                            ? handleKeyPress
                            : (e) => handleKeyPress && handleKeyPress(e)
                    }
                    enterkeyhint={enterkeyhint}
                    onClick={onClick}
                    onBlur={onBlur}
                    ref={searchRef}
                    autoComplete={autoComplete}
                />
                {searchProduct.length > 0 && (
                    <i
                        className="pi pi-times"
                        style={{ cursor: 'pointer', right: `${right}` }}
                        onClick={() => {
                            if(clearSearch) {
                                clearSearch();
                                return;
                            }
                            if (props?.clearSearch) {
                                props.clearSearch();
                            }
                            updateSearch('');
                        }}
                    />
                )}
            </StyledSpan>
        </SearchBoxContainer>
    );
};

export default SearchBox;
